import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { FormBuilder, FormControl, FormArray, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { AcademicInfoService,FutureInfoService } from '../../../_services/index';

@Component({
  selector: 'school-questiontype',
  providers:[FutureInfoService]
})
class SchoolComponent implements OnInit, OnDestroy {
  @Input() required:boolean;
  @Input() prompt:string;
  @Input() tooltip:string;
  @Input() questionid:number;
  @Input() disabled:boolean;
  value:any = '';
  formSegment:FormGroup;

  protected constructor(
    public api: any
  ){
  }

  public getValue():object {
    var result={};
    if(!this.disabled) {
      result[this.questionid]=this.formSegment.value['item'];
    } else {
      result[this.questionid]=null;
    }
    return result;
  }

  isValid():boolean {
    if(this.disabled) {
      return true;
    }
    return !this.formSegment.controls['item'].errors;
  }
  validate():boolean {
    this.formSegment.controls['item'].markAsTouched();
    return this.isValid();
  }

  get formError():string {
    var err;

    if(this.formSegment.controls['item'].dirty || this.formSegment.controls['item'].touched) {
      err=this.formSegment.controls['item'].errors;
      if(!!err && err.whitespace) {
        return 'This answer is required.';
      }
    }
    return '';
  }

  renderHero = (data: any) : string => {
    var node=document.createElement('span');
    node.appendChild(document.createTextNode(data.name));
    return node.outerHTML;
  };

  trimValidator(control: FormControl) {
    var val = control.value || '';
    if((typeof val) === 'string') {
      const isWhitespace=(control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
    }
    return null;
  }

  ngOnInit() {
    var init={};
    var validators=[];
    if(this.value!==null) {
      if((typeof this.value=='object')) {
        if('name' in this.value) {
          this.value=this.value.name;
        } else {
          this.value=null;
        }
      }
    }
    if (this.required) {
      validators.push(this.trimValidator);
    }
    init['item']=new FormControl(this.value,validators);
    this.formSegment=new FormGroup(init);
  }

  ngOnDestroy() {
  }
}

@Component({
  selector: 'college-questiontype',
  templateUrl: './college.questiontype.component.html',
  providers:[FutureInfoService]
})
export class CollegeComponent extends SchoolComponent {
  constructor(
    public api: FutureInfoService
  ) {
    super(api);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}

@Component({
  selector: 'highschool-questiontype',
  templateUrl: './highschool.questiontype.component.html',
  providers:[AcademicInfoService]
})
export class HighschoolComponent extends SchoolComponent {
  constructor(
    public api: AcademicInfoService
  ) {
    super(api);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/pages/questionnaire/elements/school.questiontype.component.ts